export const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 14.625px 80.4375px -21.9375px rgba(43, 37, 37, 0.12)",
    borderRadius: "10.2375px",
    px: { xs: 2, sm: 3, lg: 4 },
    py: { xs: 1, sm: 2, lg: 3 },
  },
};
